module.exports = __webpack_public_path__ + "static/media/book-open.e567d860.svg";